export enum HttpErrorCode {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  TOO_MANY_REQUESTS = 429,
  SERVICE_UNAVAILABLE = 503,
}

export enum HttpCode {
  ERR_NETWORK = 'ERR_NETWORK',
  ECONNABORTED = 'ECONNABORTED',
  ERR_CANCELED = 'ERR_CANCELED',
}
